/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsResourceControllerUpdateMutationRequest, IntegrationsResourceControllerUpdateMutationResponse, IntegrationsResourceControllerUpdatePathParams, IntegrationsResourceControllerUpdate400, IntegrationsResourceControllerUpdate401, IntegrationsResourceControllerUpdate403, IntegrationsResourceControllerUpdate404 } from "../../models/integrationsController/IntegrationsResourceControllerUpdate";

function getIntegrationsResourceControllerUpdateUrl(id: IntegrationsResourceControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/integrations/${id}` as const }  
  return res
}

/**
 * @summary Re-point an integration at a different external project, or reactivate an expired one
 * {@link /api/v1/integrations/:id}
 */
export async function integrationsResourceControllerUpdate(id: IntegrationsResourceControllerUpdatePathParams["id"], data?: IntegrationsResourceControllerUpdateMutationRequest, config: Partial<RequestConfig<IntegrationsResourceControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<IntegrationsResourceControllerUpdateMutationResponse, ResponseErrorConfig<IntegrationsResourceControllerUpdate400 | IntegrationsResourceControllerUpdate401 | IntegrationsResourceControllerUpdate403 | IntegrationsResourceControllerUpdate404>, IntegrationsResourceControllerUpdateMutationRequest>({ method : "PATCH", url : getIntegrationsResourceControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}